import { type LoginNamespace } from '../en-US/login';

export const login = {
  join_button: 'Únete ahora',
  join_subtitle: 'Una alternativa de atención médica asequible y confiable',
  join_title: 'Únase a Medi-Share',
  login: 'Iniciar Sesión',
  login_subtitle: 'Inicie sesión para ver y administrar su cuenta',
  login_title: 'Inicio de sesión de miembro',
  privacy_disclaimer_text: 'Nuestro inicio de sesión seguro para miembros protege su información privada y le permite acceder a información importante sobre su membresía de Medi-Share. Observe nuestra <privacyLink>Política de Privacidad</privacyLink>.',
  register_link: 'Regístrate ahora',
  registered_text: '¿No registrado? ',
} as const satisfies LoginNamespace;
